import React from 'react';
import { QueryProvider } from './providers/QueryProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { RouterProvider } from './providers/RouterProvider';
import { AuthProvider } from './providers/AuthProvider';
import { ErrorTrackingProvider } from './providers/ErrorTrackingProvider';
import { BreadcrumbProvider } from '../contexts/BreadcrumbContext';
import { NotificationProvider, ConfirmationProvider } from '@shared/components';

const App: React.FC = () => {
  return (
    <QueryProvider>
      <ThemeProvider>
        <AuthProvider>
          <ErrorTrackingProvider>
            <NotificationProvider>
              <ConfirmationProvider>
                <BreadcrumbProvider>
                  <RouterProvider />
                </BreadcrumbProvider>
              </ConfirmationProvider>
            </NotificationProvider>
          </ErrorTrackingProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryProvider>
  );
};

export default App;
